<div class="modal-dialog m-0 legal-modal">
  <div class="modal-head d-flex align-items-start justify-content-between gap-3">
    <div>
      <!-- <h4 class="modal-title fs-24 fw-500 m-0">Legal Documents</h4> -->
       <img src="assets/images/img/logo-main.png">
      <p class="accepting-as fs-14 m-0 mt-1" *ngIf="userEmail">
        Accepting as <strong>{{ userEmail }}</strong>
      </p>
      <!-- <p class="modal-sub fs-14 m-0 mt-1">
        {{ activeTab === tab.TERMS
            ? 'Please review the Terms & Conditions, then continue to the Privacy Policy.'
            : 'Please review the Privacy Policy, then accept to continue.' }}
      </p> -->
    </div>
    <img src="assets/images/icons/cross-icon.svg" alt="" class="cursor close-icon" (click)="onClose()">
  </div>

  <div class="modal-tabs d-flex gap-4">
    <button type="button" class="modal-tab fs-15 fw-500" [class.active]="activeTab === tab.TERMS"
      (click)="setTab(tab.TERMS)">Terms &amp; Conditions</button>
    <!-- locked until the terms have been read to the end -->
    <button type="button" class="modal-tab fs-15 fw-500" [class.active]="activeTab === tab.PRIVACY"
      [class.is-locked]="!documentScrolled" [disabled]="!documentScrolled"
      [title]="documentScrolled ? '' : 'Scroll to the end of the Terms & Conditions to continue'"
      (click)="setTab(tab.PRIVACY)">Privacy Policy</button>
  </div>

  <div class="legal-body-wrap">
  <div class="modal-body legal-doc show-scroll-bar" id="legalModalBody" (scroll)="onBodyScroll()">
    <ng-container *ngIf="activeTab === tab.PRIVACY">
      <p class="doc-meta">Recuvery &middot; Privacy Policy &middot; Last updated September 17, 2025</p>

      <h3>1. Our Commitment to Your Privacy</h3>
      <p>This privacy policy has been compiled to better serve those who are concerned with how their Personally
        Identifiable Information (PII) is being used online. PII, as described in US privacy law and information
        security, is information that can be used on its own or with other information to identify, contact, or locate a
        single person, or to identify an individual in context.</p>
      <p>This policy explains how Recuvery (&ldquo;we,&rdquo; &ldquo;us,&rdquo; &ldquo;our&rdquo;) collects, uses,
        discloses, and safeguards your data when you visit our website, www.recuvery.com, and use our services
        (collectively, "Services"). Please read our privacy policy carefully to get a clear understanding of how we
        handle your information.</p>

      <h3>2. Information We Collect</h3>
      <p><strong>A. Information You Provide Directly</strong></p>
      <p>When registering on our site or apps, or when submitting forms, you may be asked to provide information such
        as:</p>
      <ul>
        <li><strong>Contact Identifiers:</strong> Name, email address, phone number.</li>
        <li><strong>Sensitive Personal Information (SPI):</strong> Social Security Number, government-issued IDs, and
          any associated data like document images.</li>
        <li><strong>Financial Information:</strong> Other contact or financial information.</li>
      </ul>
      <p><strong>Purpose of Collection:</strong> This information is used to provide the services offered by Recuvery.
        We use your Contact Identifiers and Financial Information to create your account, process transactions, and
        manage your payment plan. The app may share certain information or user images with the company's validation
        department for the explicit purpose of service delivery and fraud detection.</p>
      <p><strong>For Identity Verification and Legal Compliance:</strong> We are required by law to collect SPI, such as
        your SSN, to verify your identity and comply with federal financial regulations, including Know Your Customer
        (KYC) and Anti-Money Laundering (AML) requirements. This is crucial for fraud prevention and ensuring the
        security of our financial services.</p>
      <p><strong>B. Information We Collect Automatically (Usage Data)</strong></p>
      <p>When you use our website, we automatically collect Usage Data about your device and browsing activity using
        cookies and similar tracking technologies. This includes your IP address, browser type, pages visited, and time
        spent on pages.</p>

      <h3>3. Our Use of Cookies and Tracking Technologies</h3>
      <p>We use cookies, pixels, and other tracking technologies for analytics, personalization, and marketing purposes.
        These technologies will not be enabled until you provide affirmative consent through our cookie and tracking
        consent banner. You may change or withdraw your consent at any time by adjusting your browser settings or by
        contacting us at support&#64;recuvery.com.</p>
      <p>We use cookies and similar technologies to:</p>
      <ul>
        <li>Make our website function correctly.</li>
        <li>Compile aggregate data about site traffic and interactions to improve our services.</li>
        <li>Analyze performance and user behavior to enhance our platform.</li>
        <li>Deliver personalized advertising to you on other websites.</li>
      </ul>
      <p>Typical technologies we use:</p>
      <ul>
        <li><strong>Performance and Analytics Cookies:</strong> Used to understand user behavior (e.g., Google
          Analytics).</li>
        <li><strong>Targeting and Advertising Cookies:</strong> Used to build a profile of your interests and show you
          relevant ads. This includes Meta Pixel (Facebook Pixel). Meta Pixel may collect information in real time about
          pages you view, buttons you click, and data you enter into forms, transmitting it directly to Meta Platforms,
          Inc. Meta may combine this data with other information it has about you and use it for its own business
          purposes, subject to its privacy policy. We do not deploy Meta Pixel until you have provided affirmative
          consent. Meta Pixel is not deployed on pages where you submit Social Security Numbers, government IDs, or
          financial account numbers unless necessary for site functionality and with your explicit consent.</li>
        <li><strong>Functional Cookies:</strong> Used to enable non-essential features like live chat (e.g., Intercom).
        </li>
      </ul>
      <p>You can exercise your rights under the CCPA and manage your consent for these technologies through our Cookie
        Consent Banner. You may also request deletion of any personal data collected through Meta Pixel by following the
        instructions in the &ldquo;Your California Privacy Rights&rdquo; section of this policy.</p>

      <h3>4. How We Use Your Information</h3>
      <ul>
        <li>To provide, operate, and maintain our Services.</li>
        <li>To quickly process your transactions.</li>
        <li>To follow up with you after correspondence (live chat, email, or phone inquiries).</li>
        <li>To improve and personalize our website.</li>
        <li>To measure the effectiveness of advertising.</li>
        <li>To enhance security, prevent fraud, and comply with legal obligations.</li>
      </ul>

      <h3>5. How We Disclose Your Information (Third-Party Disclosure)</h3>
      <p>We may disclose your information to certain third parties for business purposes. We do not sell your personal
        information for monetary compensation. The categories of third parties with whom we may share your information
        include:</p>
      <ul>
        <li><strong>Service Providers:</strong> Trusted third parties who perform services on our behalf (hosting,
          analytics, customer support). These parties are contractually obligated to keep your information confidential
          and use it only for the services we ask them to perform.</li>
        <li><strong>Advertising Partners:</strong> We may share information with advertising partners (e.g., Meta)
          through cookies and similar technologies only after you have provided affirmative consent. Under California
          law, this may be considered a "sale" or "sharing" of personal information. You have the right to opt out; we
          provide direct links to Meta&rsquo;s ad preference controls when applicable.</li>
        <li><strong>Legal and Safety:</strong> We may also release information when appropriate to comply with the law,
          enforce our site policies, or protect ours or others' rights, property, or safety.</li>
      </ul>

      <h3>6. Your Data Protection Rights (California Residents &ndash; CCPA)</h3>
      <ul>
        <li><strong>Right to Know:</strong> Request information about personal information collected in the past 12
          months (up to twice in a 12-month period).</li>
        <li><strong>Right to Delete:</strong> Request deletion of personal information, subject to legal limitations.
        </li>
        <li><strong>Right to Correct:</strong> Request correction of inaccurate personal information.</li>
        <li><strong>Right to Opt-Out of Sale/Sharing:</strong> Request to opt out of the "sale" or "sharing" of personal
          information for cross-context behavioral advertising.</li>
        <li><strong>Right to Limit Use of SPI:</strong> Request limits on the use of Sensitive Personal Information to
          what is necessary to provide requested services.</li>
        <li><strong>Non-Discrimination:</strong> We will not discriminate against you for exercising your CPRA/CCPA
          rights.</li>
      </ul>
      <p><strong>How to Exercise Your Rights:</strong> To submit a request, contact us at legal&#64;recuvery.com. We may
        need to verify your identity before responding.</p>

      <h3>7. Data Security and Fair Information Practices</h3>
      <ul>
        <li>We use encryption to protect user data in transit and at rest.</li>
        <li>We implement strict access controls, granting access only to authorized personnel on a need-to-know basis.
        </li>
        <li>We regularly audit our systems and scan for malware.</li>
        <li>In line with Fair Information Practices, should a data breach occur, we will notify you via email within 7
          business days without unreasonable delay.</li>
      </ul>

      <h3>8. Telephone Monitoring</h3>
      <p>All telephone conversations between you and Recuvery may be monitored and recorded for record-keeping,
        training, and quality-assurance purposes.</p>

      <h3>9. SMS Communication Policy</h3>
      <p>We do not share or sell any SMS opt-in data or phone numbers for the purpose of SMS marketing or
        communication.</p>

      <h3>10. Additional Policies</h3>
      <ul>
        <li><strong>Do Not Track:</strong> Our systems currently do not recognize or respond to Do Not Track (DNT)
          signals.</li>
        <li><strong>Global Privacy Control &amp; CIPA:</strong> We treat Global Privacy Control (GPC) signals as a valid
          request to opt out of any non-essential tracking, including Meta Pixel. Consistent with CIPA, we do not enable
          tools that capture or transmit your interactions in real time without your express consent.</li>
        <li><strong>COPPA:</strong> We do not specifically market to children under the age of 13.</li>
      </ul>

      <h3>11. Changes to This Privacy Policy</h3>
      <p>We will notify users of any privacy policy changes on our Privacy Policy Page.</p>

      <h3>12. Contact Us</h3>
      <p>If you have questions, concerns, or requests regarding this Privacy Policy, please contact us at
        legal&#64;recuvery.com.</p>

      <p>&copy; Recuvery. All rights reserved.</p>
    </ng-container>

    <ng-container *ngIf="activeTab === tab.TERMS">
      <p class="doc-meta">Recuvery &middot; Terms and Conditions &middot; Last updated April 21, 2025</p>

      <h3>1. Introduction and Acceptance of Terms</h3>
      <p>Welcome to Recuvery (hereinafter "Recuvery," "we," "us," or "our"). These Terms and Conditions ("Terms") govern
        your access to and use of our platform and related debt collection and billing services (collectively, the
        "Services").</p>
      <ul>
        <li><strong>Client:</strong> Refers to the business entity or individual who engages Recuvery's Services to
          recover outstanding debts owed to them.</li>
        <li><strong>Debtor:</strong> Refers to the individual or business entity alleged to owe a debt that Recuvery is
          attempting to collect on behalf of a Client.</li>
        <li><strong>You:</strong> May refer to either the Client or the Debtor, depending on the context.</li>
      </ul>
      <p>By creating an account, submitting debt for collection (if you are a Client), interacting with our collection
        communications (if you are a Debtor), or otherwise accessing or using our Services, you acknowledge that you
        have read, understood, and agree to be bound by these Terms and our Privacy Policy. If you do not agree to these
        Terms, you must not use or access the Services.</p>

      <h3>2. Scope of Services</h3>
      <p>Recuvery provides third-party debt collection services for both Consumer Debts and Commercial Debts.</p>
      <ul>
        <li><strong>Consumer Debt:</strong> An obligation or alleged obligation of a natural person (consumer) to pay
          money arising out of a transaction in which the money, property, insurance, or services which are the subject
          of the transaction are primarily for personal, family, or household purposes.</li>
        <li><strong>Commercial Debt:</strong> An obligation or alleged obligation of a business entity (including
          corporations, LLCs, partnerships, sole proprietorships, etc.) or an individual to pay money arising out of a
          transaction where the subject of the transaction is primarily for business or commercial purposes. This
          includes, but is not limited to, trade credit, business loans, commercial leases, and amounts owed for
          business goods or services.</li>
      </ul>

      <h3>3. Eligibility</h3>
      <p>To use our Services as a Client or establish a payment plan as a Debtor, you must be at least 18 years old and
        capable of entering into a legally binding agreement. If you are accessing the Services on behalf of a business
        entity (as either Client or Debtor), you represent and warrant that you have the authority to bind that entity
        to these Terms.</p>

      <h3>4. User Accounts (Primarily for Clients)</h3>
      <ul>
        <li><strong>Registration:</strong> Clients may need to create an account to submit debts and manage their
          portfolio. You agree to provide accurate, current, and complete information during registration and to
          maintain the accuracy of this information.</li>
        <li><strong>Account Security:</strong> You are responsible for safeguarding your account credentials and for all
          activities occurring under your account. Notify us immediately of any suspected unauthorized use.</li>
      </ul>

      <h3>5. Consent to Electronic Notifications</h3>
      <p>By using our Services, you acknowledge and agree that we may provide you with any notices, disclosures,
        agreements, or other communications (collectively, &ldquo;Notices&rdquo;) regarding our Services electronically.
        This consent applies to all interactions and transactions with us in connection with the Services, including any
        updates or changes to these Terms and Conditions.</p>
      <p><strong>Methods of Electronic Delivery:</strong> We may provide Notices to you electronically by:</p>
      <ul>
        <li>Sending them to the email address you have provided, or</li>
        <li>Posting the Notices within our Services (e.g., through our website, user dashboard, or mobile application).
        </li>
      </ul>
      <p><strong>Duty to Update Contact Information:</strong> It is your responsibility to ensure that the email address
        and other contact information you have provided to us remain up to date. If any of your contact information
        changes, please update it promptly by following the instructions provided in your account settings or by
        contacting our customer support.</p>
      <p><strong>Legal Effect:</strong> Your consent to receive electronic Notices has the same legal effect as if we
        provided them to you in paper form. You agree that such electronic delivery satisfies any legal requirement that
        Notices be provided in writing, to the fullest extent permitted by California law and any other applicable
        regulations.</p>
      <p>By continuing to use our Services, you confirm your consent to the above terms and agree that you have the
        ability to receive, read, and store Notices delivered electronically. If you do not agree to these terms, you
        must discontinue your use of our Services.</p>

      <h3>6. Use of Services &amp; Applicable Laws</h3>
      <p><strong>License Grant (Clients):</strong> We grant Clients a limited, non-exclusive, non-transferable,
        revocable license to use our platform for submitting and managing debts, subject to these Terms.</p>
      <p><strong>Compliance with Laws:</strong> Recuvery conducts its collection activities in accordance with
        applicable federal, state, and local laws.</p>
      <ul>
        <li><strong>Consumer Debt Collection:</strong> Primarily governed by the federal Fair Debt Collection Practices
          Act (FDCPA), the California Rosenthal Fair Debt Collection Practices Act (RFDCPA), and other applicable
          state/local consumer protection laws. These laws provide specific protections to consumers regarding
          communication times, harassment, misrepresentation, validation of debts, and disputes.</li>
        <li><strong>Commercial Debt Collection:</strong> Generally excluded from the FDCPA. Collection practices are
          governed by applicable state laws (which may vary significantly), the terms of the underlying contract between
          the original creditor and the Debtor, the Uniform Commercial Code (UCC) where applicable, and general
          prohibitions against fraudulent, deceptive, or unfair business practices. <strong>Note for California
            Commercial Debtors:</strong> Certain provisions of the RFDCPA may apply to specific types of commercial debt
          transactions under California law (e.g., pursuant to SB 1286 amendments); Recuvery will comply with such
          applicable provisions.</li>
      </ul>
      <p><strong>Prohibited Activities (All Users):</strong> You agree not to:</p>
      <ul>
        <li>Use the Services for any illegal, fraudulent, deceptive, or unauthorized purpose.</li>
        <li>Interfere with or disrupt the integrity or performance of the Services.</li>
        <li>Attempt to gain unauthorized access to the Services or related systems.</li>
        <li>Provide false or misleading information to Recuvery.</li>
        <li>Violate any applicable laws or regulations in connection with your use of the Services.</li>
      </ul>

      <h3>7. Client Obligations (Specific to Clients)</h3>
      <p>By submitting any debt (Consumer or Commercial) to Recuvery for collection, you, the Client, represent,
        warrant, and agree that:</p>
      <ul>
        <li><strong>Validity of Debt:</strong> The debt is a valid, legally owed obligation, due and payable in the
          amount submitted, arising from a legitimate transaction.</li>
        <li><strong>Accuracy of Information:</strong> All information provided about the Debtor and the debt is accurate
          and complete to the best of your knowledge.</li>
        <li><strong>Documentation:</strong> You possess and will provide Recuvery, upon request, with all necessary
          documentation to substantiate the debt (e.g., contracts, invoices, statements of account, proof of delivery,
          personal guarantees if applicable). For Commercial Debts, this includes the underlying commercial agreement.
        </li>
        <li><strong>Authority:</strong> You have the full legal right and authority to place the debt with Recuvery for
          collection.</li>
        <li><strong>No Prior Disputes (Undisclosed):</strong> You have disclosed any known disputes, defenses, or
          counterclaims raised by the Debtor regarding the debt.</li>
        <li><strong>Compliance:</strong> The underlying transaction giving rise to the debt complied with all applicable
          laws.</li>
        <li><strong>Indemnification:</strong> You agree to indemnify and hold harmless Recuvery from any claims,
          damages, losses, liabilities, costs, and expenses (including reasonable attorneys' fees) arising out of or
          related to: (i) any breach of your representations and warranties herein; (ii) the invalidity or
          unenforceability of the debt placed; (iii) failure to provide accurate information or necessary
          documentation; or (iv) any act or omission by you that violates applicable law related to the debt prior to
          placement.</li>
      </ul>

      <h3>8. Debtor Communications and Rights</h3>
      <ul>
        <li><strong>Communications:</strong> Recuvery will communicate with Debtors in a professional manner and in
          accordance with applicable laws governing the type of debt (Consumer or Commercial).</li>
        <li><strong>Consumer Debtor Rights:</strong> Consumer Debtors have specific rights under the FDCPA and RFDCPA
          (and other applicable state laws), including the right to request debt validation, dispute the debt, specify
          communication preferences, and be free from harassment or abuse. Recuvery will honor these rights as required
          by law. Information regarding these rights will be provided in initial communications as legally mandated.
        </li>
        <li><strong>Commercial Debtor Communications:</strong> While FDCPA restrictions generally do not apply, Recuvery
          will adhere to professional standards and applicable state laws governing commercial collections.
          Communications will typically be directed to the appropriate contact person within the business entity.</li>
        <li><strong>Disputes:</strong> All Debtors (Consumer and Commercial) have the right to dispute the validity of a
          debt or the amount owed. Recuvery will investigate disputes as required by law and internal policy. For
          Consumer Debts, specific procedures under FDCPA/RFDCPA apply. For Commercial Debts, resolution often depends
          on the underlying contract and applicable state law.</li>
      </ul>

      <h3>9. Payments</h3>
      <p><strong>Payment Agreements:</strong> Recuvery may, at its sole discretion, negotiate and establish a payment
        plan for the Debtor on behalf of the Client as part of its Billing or Debt Collection services, subject to
        Client guidelines and applicable laws.</p>
      <p>For each successful transaction, Recuvery will charge a service fee, which it will assess and deduct before
        transferring the remaining funds to the Client. Payment plans may also be reported to the Credit Report
        Agencies.</p>

      <h3>10. Fees and Compensation</h3>
      <ul>
        <li><strong>Service Fees.</strong> Recuvery will assess a service fee on every successful billing or collection,
          which includes, but is not limited to, payment plans, one-time payments, and partial payments.</li>
        <li><strong>Deduction of Fees.</strong> This service fee shall be deducted from the amounts collected from
          Customers prior to remittance to you.</li>
        <li><strong>Fee Schedule.</strong> The applicable service fees are outlined in Exhibit A attached hereto and
          incorporated herein by reference.</li>
      </ul>
      <p><strong>10.1 Billing Service Fee</strong></p>
      <p>For Billing Services, Recuvery charges a portion of any successfully collected amount prior to disbursing the
        net balance to the Client.</p>
      <p><strong>10.2 Debt Collection Fee Structure</strong></p>
      <p>For Debt Collection Services, the fee structure may differ and is typically based on:</p>
      <ul>
        <li>Success-based commission (percentage of the amount recovered)</li>
        <li>Tiered structure based on the age of the debt</li>
        <li>Negotiated discount arrangement</li>
        <li>All costs relating to transaction fees (including Stripe fees), communication, dispute process, credit
          reporting, letters, and other collection activities are borne by Recuvery unless otherwise agreed in writing
        </li>
      </ul>
      <p><strong>10.3 Changes to Fees</strong></p>
      <p>We reserve the right to modify our fees at any time. Any changes will become effective after providing prior
        written or electronic notice to the Client, and your continued use of the Services after such notice constitutes
        acceptance of the revised fees.</p>

      <h3>11. Data Collection and Use</h3>
      <p>Recuvery collects and analyzes payment data, communications, and other relevant metrics to improve collection
        strategies, optimize discount offers, and streamline the billing process.</p>
      <p>By using Recuvery&rsquo;s Services, the Client and Debtor authorize Recuvery to retain and use de-identified or
        aggregate data for internal analytics and product improvement.</p>

      <h3>12. Privacy and Security</h3>
      <p>Recuvery implements industry-standard security measures to protect personal and financial data.</p>
      <p>Your use of the Services is also governed by our Privacy Policy, which describes how we collect, use, and
        disclose your personal information.</p>
      <p><strong>12.1 California Consumer Privacy Act (CCPA) Compliance</strong></p>
      <p>If you are a California resident, you have specific rights under the CCPA regarding your personal
        information:</p>
      <ul>
        <li><strong>Right to Know:</strong> You have the right to request that we disclose what personal information we
          collect, use, disclose, and sell.</li>
        <li><strong>Right to Delete:</strong> You have the right to request the deletion of your personal information
          that we have collected.</li>
        <li><strong>Right to Opt-Out:</strong> We do not sell your personal information. If we ever decide to sell
          personal information, you have the right to opt-out.</li>
        <li><strong>Non-Discrimination:</strong> We will not discriminate against you for exercising any of your CCPA
          rights.</li>
      </ul>
      <p>To exercise your CCPA rights, please contact us at:</p>
      <ul>
        <li>Email: privacy&#64;recuvery.com</li>
        <li>Phone: (833) 904-7001</li>
        <li>Address: 1 Technology Dr Suite J-703, Irvine, CA 92618</li>
      </ul>
      <p><strong>12.2 Shine the Light Law</strong></p>
      <p>California's "Shine the Light" law permits users who are California residents to request certain information
        regarding our disclosure of personal information to third parties for their direct marketing purposes. To make
        such a request, please contact us at privacy&#64;recuvery.com.</p>

      <h3>13. Authorization to Handle Protected Health Information (PHI)</h3>
      <ul>
        <li><strong>Scope of Authorization:</strong> Client authorizes Recuvery to receive, access, and use Protected
          Health Information (PHI) solely for the purpose of performing billing or debt collection services. Such use
          must comply with applicable federal, state, and local laws, including but not limited to HIPAA.</li>
        <li><strong>Minimum Necessary Information:</strong> Client agrees to disclose only the minimum necessary PHI
          required to facilitate the collections process. This information may include, but is not limited to, customer
          names, account balances, dates of service, and general descriptions of services rendered.</li>
        <li><strong>Patient Authorization:</strong> Client warrants that it has obtained all necessary written patient
          authorizations for the release of PHI to Recuvery in accordance with HIPAA requirements. Such authorizations
          will specify the purpose of disclosure and the parties authorized to receive the information.</li>
        <li><strong>Retention and Disposal:</strong> Recuvery shall retain PHI only as long as necessary to fulfill its
          obligations under this agreement and shall ensure the secure disposal or return of PHI upon termination of
          this agreement or completion of the collections process, in compliance with applicable laws.</li>
      </ul>

      <h3>14. Disputes and Consumer Reporting</h3>
      <p><strong>14.1 Disputes</strong></p>
      <ul>
        <li>Recuvery may handle dispute resolution with Debtors, third-party payment processors (like Stripe), and CRAs.
        </li>
        <li>The Debtor or Client agrees to cooperate in good faith if Recuvery requires additional information to
          resolve any disputes.</li>
      </ul>
      <p><strong>14.2 Credit Reporting</strong></p>
      <ul>
        <li>Recuvery may report Debtor payment statuses (including delinquencies and defaults) to Credit Reporting
          Agencies (CRAs), as permitted by law.</li>
        <li>If a Debtor believes information reported by Recuvery is incorrect, the Debtor may contact Recuvery to
          dispute the accuracy of the reported data.</li>
      </ul>

      <h3>15. Intellectual Property</h3>
      <p>The Services, including the platform, software, and content (excluding Client or Debtor data), are the property
        of Recuvery and protected by intellectual property laws.</p>

      <h3>16. Third-Party Links</h3>
      <p>Our Services may contain links to third-party websites or services that are not owned or controlled by us. We
        are not responsible for the content, policies, or practices of any third-party sites.</p>

      <h3>17. Termination</h3>
      <p>We may terminate or suspend your account and access to the Services at our sole discretion, without prior
        notice, for conduct that we believe violates these Terms.</p>

      <h3>18. Disclaimers</h3>
      <p><strong>No Guarantee of Recovery:</strong> Recuvery does not guarantee the successful collection of any debt
        placed by a Client. Collection success depends on various factors, including the age of the debt, the Debtor's
        financial situation, and the availability of supporting documentation.</p>
      <p><strong>Services "As Is":</strong> The Services are provided "as is" and "as available" without warranties of
        any kind, either express or implied, including, but not limited to, implied warranties of merchantability,
        fitness for a particular purpose, or non-infringement.</p>

      <h3>19. Limitation of Liability</h3>
      <p>To the fullest extent permitted by law, Recuvery shall not be liable for any direct, indirect, incidental,
        special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or
        indirectly, or any loss of data, use, goodwill, or other intangible losses, resulting from (a) your access to or
        use of or inability to access or use the Services; (b) any conduct or content of any third party on the
        Services; (c) any content obtained from the Services; or (d) unauthorized access, use, or alteration of your
        transmissions or content. In no event shall Recuvery's aggregate liability for all claims relating to the
        Services exceed the greater of one hundred U.S. dollars ($100) or the amounts paid by you (if a Client) to
        Recuvery in the last six months for the Services giving rise to the claim.</p>

      <h3>20. Indemnification (General)</h3>
      <p>In addition to the Client-specific indemnification, you agree to defend, indemnify, and hold harmless Recuvery,
        its affiliates, officers, directors, employees, and agents from and against any claims, liabilities, damages,
        losses, and expenses, including reasonable attorneys' fees, arising out of or in any way connected with your
        access to or use of the Services or your violation of these Terms or applicable law.</p>

      <h3>21. Governing Law</h3>
      <p>These Terms shall be governed by and construed in accordance with the laws of the State of California, without
        regard to its conflict of law principles.</p>

      <h3>22. Arbitration, Class Action Waiver and Dispute Resolution</h3>
      <p>In the event of any dispute, claim, or controversy between or among the parties to this Agreement arising out
        of or relating to this Agreement or any breach thereof, including, without limitation, any claim that this
        Agreement or any of its parts is invalid, illegal, or otherwise voidable or void, whether such dispute, claim,
        or controversy sounds in contract, tort, equity, or otherwise, and whether such dispute, claim, or controversy
        relates to the meaning, interpretation, effect, validity, performance, or enforcement of the Agreement, such
        dispute, claim, or controversy shall be resolved as follows:</p>
      <p><strong>22.1 Informal Dispute Resolution Requirement</strong></p>
      <p>Before commencing arbitration, the party asserting the dispute shall first provide written notice to the other
        party, describing in detail the nature and basis of the claim and the relief sought. The parties shall then
        engage in good-faith negotiations to attempt to resolve the dispute without the need for arbitration. This
        informal dispute resolution period shall last no less than 60 days from receipt of the written notice, unless
        the parties mutually agree to a shorter period. Any notices to Recuvery shall be sent to: Legal Department,
        Recuvery LLC, 1 Technology Dr Suite J-703, Irvine, CA 92618, USA or legal&#64;recuvery.com.</p>
      <p><strong>22.2 Arbitration Agreement</strong></p>
      <p>If the parties are unable to resolve the dispute within the informal resolution period, such dispute shall be
        settled by and through an arbitration proceeding to be administered by the American Arbitration Association (or
        any like organization successor thereto) in Orange County, California, in accordance with the American
        Arbitration Association&rsquo;s Commercial Arbitration Rules. Each of the parties to this Agreement hereby
        agrees and consents to such venue and waives any objection thereto. The arbitrability of any such dispute,
        claim, or controversy shall likewise be determined in such arbitration. Such arbitration proceedings shall be
        conducted in as expedited a manner as is then permitted by the commercial arbitration rules (formal or informal)
        of the American Arbitration Association. Both the foregoing agreement of the parties to arbitrate any and all
        such disputes, claims, and controversies and the results, determinations, findings, judgments, and/or awards
        rendered through any such arbitration shall be final and binding on the parties and may be specifically enforced
        by legal proceedings. Notwithstanding any provision of this Agreement relating to which state laws govern this
        Agreement, all issues relating to arbitrability or the enforcement of the agreement to arbitrate contained
        herein shall be governed by the Federal Arbitration Act (9 U.S.C. &sect;&sect; 1 et seq.) and the federal common
        law of arbitration.</p>
      <p><strong>22.3 Mass Arbitration Procedures</strong></p>
      <p>If 25 or more similar arbitration demands are presented by or with the assistance or coordination of the same
        law firm, group of law firms, or organization within a 90-day period (&ldquo;Mass Filing&rdquo;), the parties
        agree that the American Arbitration Association&rsquo;s (&ldquo;AAA&rdquo;) Mass Arbitration Supplementary Rules
        shall apply. If the AAA does not have such rules in effect, the parties agree to: (i) batch the arbitration
        demands into groups of no more than 25 claims per group; (ii) resolve each group in a staged manner, with the
        resolution of each group informing potential resolution of remaining groups; and (iii) toll any applicable
        statute of limitations for the remaining claims during this staged process. The parties further agree that they
        will work in good faith to implement alternative procedures that may reduce the costs and burdens of
        arbitration, including, without limitation, mediation or a global settlement process, before proceeding with
        additional batches. The payment of AAA fees for any Mass Filing shall be governed by AAA rules as modified by
        this provision, and the arbitrator shall have the authority to allocate such fees in a manner consistent with
        applicable law.</p>
      <p><strong>22.4 Class Action Waiver</strong></p>
      <p>The parties agree that any arbitration or legal proceeding shall be conducted only on an individual basis and
        not as a class, consolidated, or representative action. The arbitrator may not consolidate the claims of more
        than one person or preside over any form of class or representative proceeding. By agreeing to arbitration, the
        parties are waiving their right to participate in or bring a class action in any forum.</p>
      <p><strong>22.5 Survival</strong></p>
      <p>This Arbitration, Class Action Waiver, and Dispute Resolution provision shall survive the termination of this
        Agreement.</p>

      <h3>23. Changes to Terms</h3>
      <p>We reserve the right to modify these Terms at any time. We will notify Clients of significant changes (e.g.,
        via email or platform notification). Changes will be effective immediately upon posting the updated Terms on our
        website, with the "Last Updated" date revised. Your continued use of the Services after changes are posted
        constitutes your acceptance of the revised Terms.</p>

      <h3>24. Severability</h3>
      <p>If any provision of these Terms is held to be invalid, illegal, or unenforceable, the validity, legality, and
        enforceability of the remaining provisions shall remain in full force and effect.</p>

      <h3>25. Entire Agreement</h3>
      <p>These Terms, together with the Privacy Policy and any specific Service Agreement or Fee Schedule provided to
        Clients, constitute the entire agreement between you and Recuvery regarding the Services and supersede all prior
        or contemporaneous agreements, understandings, representations, and warranties, whether written or oral.</p>

      <h3>26. Contact Information</h3>
      <p>If you have any questions about these Terms, please contact us at:</p>
      <ul>
        <li>Email: support&#64;recuvery.com</li>
        <li>Address: 1 Technology Dr Suite J-703, Irvine, CA 92618</li>
      </ul>

      <h3>Exhibit A</h3>
      <p><strong>Service Fee Schedule</strong></p>
      <p>Base Collection and Discount Rates by Debt Age</p>
      <div class="doc-table-wrap">
        <table class="doc-table">
          <thead>
            <tr>
              <th>Debt Age</th>
              <th>Base Collection Rate (%)</th>
              <th>Base Discount Rate (%)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>0-90 Days</td>
              <td>15%</td>
              <td>10%</td>
            </tr>
            <tr>
              <td>91-180 Days</td>
              <td>20%</td>
              <td>12%</td>
            </tr>
            <tr>
              <td>181-360 Days</td>
              <td>25%</td>
              <td>15%</td>
            </tr>
            <tr>
              <td>361-540 Days</td>
              <td>30%</td>
              <td>17%</td>
            </tr>
            <tr>
              <td>541-720 Days</td>
              <td>35%</td>
              <td>20%</td>
            </tr>
            <tr>
              <td>721-900 Days</td>
              <td>40%</td>
              <td>25%</td>
            </tr>
            <tr>
              <td>901-1,095 Days</td>
              <td>45%</td>
              <td>30%</td>
            </tr>
            <tr>
              <td>1,096-1,460 Days (4 Years)</td>
              <td>48%</td>
              <td>40%</td>
            </tr>
            <tr>
              <td>1,461-1,825+ Days (5+ Years)</td>
              <td>50%</td>
              <td>50%</td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>
  </div>

  <!-- sits over the body rather than inside it, so it stays put while the text scrolls;
       kept out of the acceptance capture -->
  <button type="button" class="scroll-bottom-btn" *ngIf="!bodyAtBottom && !capturing"
    aria-label="Scroll to the bottom" (click)="scrollToBottom()">
    <img src="assets/images/icons/down-arrow.svg" alt="">
  </button>
  </div>

  <div class="modal-foot">
    <!-- <p class="scroll-hint fs-13 mb-0" *ngIf="activeTab === tab.TERMS && !documentScrolled">
      Please scroll to the end of the Terms &amp; Conditions to accept them.
    </p> -->
    <div class="agree-row" *ngIf="canAccept" [class.is-disabled]="!documentScrolled">
      <input type="checkbox" class="pointer primary-checkbox" id="legalAgree" [(ngModel)]="agreeChecked"
        [disabled]="!documentScrolled">
      <label for="legalAgree" class="mb-0 fs-14">
        <ng-container *ngIf="accepterName; else agreeWithoutName">I,
          <strong>{{ accepterName }}</strong>, accept the <strong>terms and conditions</strong> &amp;
          the <strong>privacy policy</strong>.</ng-container>
        <ng-template #agreeWithoutName>I agree to the <strong>Terms and Condition</strong> and
          <strong>Privacy Policy</strong>.</ng-template>
      </label>
    </div>
    <div class="modal-actions d-flex justify-content-end gap-3">
      <button type="button" class="btn btn-default legal-btn" (click)="onClose()">Close</button>
      <button type="button" class="btn btn-primary legal-btn" *ngIf="canAccept"
        [disabled]="!documentScrolled || !agreeChecked || capturing" (click)="accept()">Accept &amp; Continue</button>
    </div>
  </div>
</div>
